import { Notification, NotificationPreferences } from '../../types/notifications.ts';
import { isInAppNotificationEnabled, NOTIFICATION_TYPES } from '../../notifications/policy.ts';

export const SUPERVISOR_ALLOWED_NOTIFICATIONS = [
  'system',
  'comment_added',
  'boq_comment_mention',
  'document_uploaded',
  'chat_message',
  'supervisor_feedback',
  'diary_reminder',
  'progress_update',
  'activity_mention',
];

/** `includeRead` turns the unread-only list into alert history. */
export interface AlertReadOptions { includeRead?: boolean }

export function filterInAppNotifications(
  notifications: Notification[],
  user: { role?: string | null } | null | undefined,
  company: { id?: string | null } | null | undefined,
  preferences: NotificationPreferences,
  options: AlertReadOptions = {}
): Notification[] {
  if (!user) {
    return [];
  }

  let filtered = notifications;

  if (user.role === 'supervisor') {
    filtered = filtered.filter(notification =>
      SUPERVISOR_ALLOWED_NOTIFICATIONS.includes(notification.type)
    );
  }

  if (user.role === 'client' && company?.id) {
    filtered = filtered.filter(notification =>
      notification.companyId === company.id || !notification.companyId
    );
  }

  // Read notifications are hidden by default so the list stays actionable and
  // the empty state ("You're all caught up") is genuinely accurate. History
  // views opt in; the unread badge count comes from the server, not this list.
  if (!options.includeRead) filtered = filtered.filter(notification => !notification.read);

  filtered = filtered.filter(notification => isInAppNotificationEnabled(notification.type, preferences));

  return filtered;
}

/** Send the same policy to the list and exact-count queries; retain local filtering too. */
export function inAppNotificationQuery(user:{role?:string|null}|null|undefined,company:{id?:string|null}|null|undefined,preferences:NotificationPreferences,options:AlertReadOptions={}) {
  return {
    types: user ? NOTIFICATION_TYPES.filter(type=>(user.role!=='supervisor'||SUPERVISOR_ALLOWED_NOTIFICATIONS.includes(type))&&isInAppNotificationEnabled(type,preferences)) : [],
    ...(user?.role==='client'&&company?.id?{companyId:company.id}:{}),
    unreadOnly:!options.includeRead,
  };
}
